var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentsData.type == 20)?_c('div',[_c('div',{staticClass:"bg-div",style:(_vm.bgStyle)},[_c('div',{staticClass:"btn-div",style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.componentsData.content.title))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }